import React, { Component } from "react";
import firebase from "../../firebase";
import "react-datepicker/dist/react-datepicker.css";

import Service from "../../Service/firebase";
import "./addbanner.css";
import NewBannerForm from "./newbannerform";

class AddBanner extends Component {
  constructor() {
    super();

    this.state = {
      imageAvatar: "",
      imagefile: "",
      date: null,
      // startDate: new Date(),
      isLoading: false,
      htmlelement: <i className="fa fa-user fa-8x" aria-hidden="true"></i>,

      formData: {
        name: "",
       
      },
    };
  }

  handleSubmit = () => {
    this.setState({
      isLoading: true,
    });
    this.props.setCloseBtnAppear();
    this.handleImageForUpload();
  };
  handleImageForUpload = () => {
    const image = this.state.imagefile;
    const url = "";

    if (this.state.imagefile !== "") {
      this.onUploadImage(image);
    } else {
      this.onAddPerson(url);
    }
  };
  onUploadImage = async (image) => {
    const url = await Service.uploadImage(image);
    if (url !== "") {
      this.onAddPerson(url);
    }
  };
  
  async onAddPerson(imageUrl) {
    let sendData = {
      ...this.state.formData,
      searchbyname: (
        this.state.formData.name 
      ).toLowerCase(),
      imgaeurl: imageUrl,
      timeStamp: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    if (this.props.collectionName === "banner") {
      sendData = {
        ...sendData,

      
      };
    }

    const res = await Service.addData(
      sendData,
      this.props.collectionName,
      this.props.id
    );

    if (res === "success") {
      this.setState({
        isLoading: false,
      });

      this.props.handleSuccessDailog();
    } else {
      this.setState({
        isLoading: false,
      });
      this.props.handleErrorDailog();
    }
  }

  handleChange = (date) => {
    if (date !== null) {
      const birthDate = new Date(date);

      this.setState({
        date: date,
        formData: {
          ...this.state.formData,
         
        },

        startDate: date,
      });
    } else {
      this.setState({
        date: date,
        formData: {
          ...this.state.formData,
       
        },

        startDate: date,
      });
    }
  };
  onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      this.setState({
        imagefile: event.target.files[0],
      });
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          imageAvatar: e.target.result,
          htmlelement: (
            <div className="addpersonpage">
              <img
                className="netimage"
                srcSet={e.target.result}
                alt="profileImage"
              />
            </div>
          ),
        });
      };
      reader.readAsDataURL(event.target.files[0]);
      this.setState({});
    }
  };
  onImageRemove = () => {
    this.setState({
      imagefile: "",
      imageAvatar: "",
      htmlelement: (
        <div className="addpersonpage">
          <i className="fa fa-user fa-8x" aria-hidden="true"></i>
        </div>
      ),
    });
  };
  onEdit = (e) => {
    const formData = this.state.formData;
    this.setState({
      formData: {
        ...formData,
        [e.target.name]: e.target.value,
      },
    });
  };

  render() {
    // if (this.state.imageAvatar === "") {
    //   this.state.htmlelement = (
    //     <div className="addpersonpage">
    //       <i className="fa fa-user fa-8x" aria-hidden="true"></i>
    //     </div>
    //   );
    // } else {
    //   this.state.htmlelement = (
    //     <div className="addpersonpage">
    //       <img className="netimage" srcSet={this.state.imageAvatar} alt="" />
    //     </div>
    //   );
    // }
    return this.state.isLoading ? (
      <div className="addpersonpage">
        <i className="fas fa-spinner fa-pulse fa-2x"></i>
      </div>
    ) : (
      <div className="addpersonpage">
        <div className="container main_section">
          <div className="row">
            <div className="col-sm">
              <NewBannerForm
                handleSubmit={this.handleSubmit}
                onEdit={this.onEdit}
                // startDate={this.state.startDate}
                date={this.state.date}
                htmlelement={this.state.htmlelement}
                handleChange={this.handleChange}
                onImageRemove={this.onImageRemove}
                onImageChange={this.onImageChange}
              ></NewBannerForm>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddBanner;
